<template>
	<component :is="transitionType" :tag="tag" v-bind="$attrs" name="stamp">
		<slot></slot>
	</component>
</template>

<script>
	export default {
		computed: {
			actionDetails() {
				return this.$store.getters[this.actionDetailsContext][this.currentAction];
			},
			currentAction() {
				return this.$store.getters[this.currentActionContext];
			},
			transitionType() {
				return this.group ? "transition-group" : "transition";
			}
		},
		data() {
			return {
				actionDetailsContext: 'navigation/actionDetails',
				currentActionContext: 'navigation/activeAction'
			}
		},
		props: {
			group: {
				type: Boolean,
				default: false,
				required: false
			},
			tag: {
				type: String,
				default: "div",
				required: false
			}
		}
	}
</script>

<style>
  .stamp-enter-active {
    animation: stamp .5s;
  }
  @keyframes stamp {
    from {
      opacity: 0.1;
      transform: scale(5.0)
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>